module.exports = __webpack_public_path__ + "static/img/portfolio-2.50e0ecd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio-2.jpg
// module id = S29U
// module chunks = 1